
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPayTermCodeGrid extends Serenity.EntityGrid<PoPayTermCodeRow, any> {
        protected getColumnsKey() { return PoPayTermCodeColumns.columnsKey; }
        protected getDialogType() { return PoPayTermCodeDialog; }
        protected getIdProperty() { return PoPayTermCodeRow.idProperty; }
        protected getInsertPermission() { return PoPayTermCodeRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPayTermCodeRow.localTextPrefix; }
        protected getService() { return PoPayTermCodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}